import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    Tab,
    Tabs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    IconButton,
    Typography,
    Checkbox,
    Tooltip,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import StarIcon from "@mui/icons-material/Star";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ width: "100%" }}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ViewHomeLayout = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    const mockProducts = [
        {
            id: "#PROD-001",
            name: "Men Sports Shoes",
            category: "Footwear",
            brand: "Nike",
            stock: 120,
            status: "Active",
            trending: { isTrending: true, type: "Auto" },
            image: "/static/images/placeholder.png",
            vendor: { name: "Mike Johnson", email: "mike@example.com" },
            rating: 4.5,
            reviewCount: 120,
            price: 150
        },
        {
            id: "#PROD-002",
            name: "Women Running Shoes",
            category: "Footwear",
            brand: "Adidas",
            stock: 45,
            status: "Active",
            trending: { isTrending: false, type: "Manual" },
            image: "/static/images/placeholder.png",
            vendor: { name: "John Doe", email: "john@example.com" },
            rating: 4.8,
            reviewCount: 45,
            price: 250
        },
    ];

    const mockCategories = [
        { id: 1, name: "Home & Kitchen", usage: "132 units", createdDate: "04 Sept 2025" },
        { id: 2, name: "Mobile Phones", usage: "170 units", createdDate: "01 Sept 2025" },
    ];

    const filteredProducts = mockProducts.filter((p) =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredCategories = mockCategories.filter((c) =>
        c.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderProductsTable = () => (
        <div className="cards">
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search products..."
                        />
                    </Box>
                </div>
            </div>
            <TableContainer className="table_container">
                <Table>
                    <TableHead>
                        <TableRow>

                            <TableCell>ID</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Brand Name</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredProducts.map((item, index) => (
                            <TableRow key={index} hover>

                                <TableCell>{item.id}</TableCell>
                                <TableCell>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                            style={{ width: "40px", height: "40px", borderRadius: "6px", objectFit: "cover", background: "#f5f5f5" }}
                                        />
                                        <p style={{ fontWeight: 600, margin: 0 }}>{item.name}</p>
                                    </Box>
                                </TableCell>
                                <TableCell>{item.brand}</TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>AED {item.price}</Typography>
                                </TableCell>
                                <TableCell>
                                    <SwitchToggle checked={item.status === 'Active'} />
                                </TableCell>
                               
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );

    const renderCategoriesTable = () => (
        <div className="cards">
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search categories..."
                        />
                    </Box>
                </div>
            </div>
            <TableContainer className="table_container">
                <Table>
                    <TableHead>
                        <TableRow>

                            <TableCell>Category Name</TableCell>
                            <TableCell>Usage</TableCell>
                            <TableCell>Created Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCategories.map((item, index) => (
                            <TableRow key={item.id} hover>

                                <TableCell>
                                    <span className="label_text" style={{ fontWeight: '600' }}>{item.name}</span>
                                </TableCell>
                                <TableCell>{item.usage}</TableCell>
                                <TableCell>{item.createdDate}</TableCell>
                              
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );

    return (
        <div className="view_page">
            <div className="main_title d_flex">
                <div className="left_">
                    <h1>View Home Layout</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/home-layout")}>Home Layout</button> - View
                    </p>
                </div>

            </div>


            <div className="cards user_info_tabs">
                <Box className="custom_tabs">
                    <Tabs
                        value={valueTabs}
                        onChange={handleChangeTabs}
                        aria-label="home layout tabs"
                        variant="scrollable"
                        className="custom_tabs_links"

                        scrollButtons="auto"
                    >
                        <Tab label="Trending Now" {...a11yProps(0)} />
                        <Tab label="Shop by Category" {...a11yProps(1)} />
                        <Tab label="Featured Products" {...a11yProps(2)} />
                        <Tab label="Shop the Reel" {...a11yProps(3)} />
                        <Tab label="New Arrivals" {...a11yProps(4)} />
                        <Tab label="Recommended Products" {...a11yProps(5)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={valueTabs} index={0}>
                    {renderProductsTable()}
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={1}>
                    {renderCategoriesTable()}
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={2}>
                    {renderProductsTable()}
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={3}>
                    {renderProductsTable()}
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={4}>
                    {renderProductsTable()}
                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={5}>
                    {renderProductsTable()}
                </CustomTabPanel>
            </div>
        </div>
    );
};

export default ViewHomeLayout;
